/*================================================================
  KD NATIVE OPTIONS, assets/kd-native-options.js
  v11, 10/8/2026, WB1 word box 10/8: the Your Word box sits right
  under the Morse Code menu, in that menu's column (placeWord).
  Specced by Opilio Claudio, built by Opilio C., pushed by Santino C.
  v10, 9/25/2026, product page tweaks (draft 76 tweaks): a pick from
  the 21 cord colors closes the list and the bar shows it; the
  review rating line goes to the reviews (REVIEWS LINE block at the
  end of this file). Spec by Fabio Claudio, built by Opilio C.
  v9, 9/25/2026, size menus (draft 72 sizes): forced size pick, the
  fit card (i) on tagged products, the second slider add-on, the
  typed-size line. Spec by Fabio Claudio, built by Opilio C.
  v8, 9/25/2026, Second Bead Color on Let Them (draft 68 let them,
  which also carries v7 from 69 cord picker).
  v7, 9/25/2026, cord picker tidy-up (draft 69 cord picker): the
  label line names the chosen color, a pick from the 21 list included.
  v6, 9/24/2026, cord color swatches and the More Colors chips
  (draft 64 swatches). v5, 9/23/2026, APO to native Phase 1 (draft
  55 apo); size box added 9/23 evening (draft 57).

  Replaces what the APO options app (Avis Plus) did on product
  pages: the word box with a letter cap, Cord Color, Custom Size and
  the gift fields. The markup is snippets/kd-native-options.liquid
  (block kd_native_opts in templates/product.json); the look is
  block 270 in assets/kd-custom-26.css. Loaded on every page from
  layout/theme.liquid, deferred.

  PRODUCT PAGE
  - Moves the fields right under the option menus (after
    variant-selects, inside div.product__form). The theme swaps the
    whole variant-selects on every option change (theme.js
    HTMLUpdateUtility.viewTransition), so nothing of ours lives
    inside it; typed text survives every swap.
  - Reads the picked value of every option and shows a field only
    when a pick calls for it (rules in section 1). A hidden field is
    emptied and never sent; its text comes back if the shopper picks
    a custom value again.
  - Word: letters and digits count one each, spaces and punctuation
    are free, emoji and symbols are refused. The cap is the top
    number of the first N-M range in the picked value, else 24.
  - Writes the properties as hidden inputs inside the product form
    (div.kd-opts-props): Your Word, Cord Color, Custom Size, Gift?,
    Gift Message, Ship to Giftee?. Only fields with a value are
    written; nothing starting with "_".
  - Add to Cart, the sticky cart bar and Buy it now are stopped
    while a shown field is empty or the word is over its cap: pink
    outline, pink line, the field scrolled into view.
  CORD COLOR MENU (KD 9/23: "Choice is forced")
  - A listing's cord color menu (an option named with "cord", or a
    colour option holding a "... Cord" or "See More Color Options"
    value, two values or more) starts on "Choose a color": nothing
    counts as picked until the shopper clicks a color in that menu.
    Add to Cart, the sticky bar and Buy it now stop until then (pink
    outline, "Please choose a color." under the menu). A page opened
    with ?variant= in the address counts as picked (a Google Shopping
    or shared link names its color). The look is block 272 in
    assets/kd-custom-26.css (its Popular tag is off wherever the
    swatch row shows, KD 9/25).
  - See More Color Options (MORE Strand / Color Options on listings
    not yet renamed) opens the More Colors box, saved as Cord Color.
  SWATCHES (v6, KD 9/24)
  - Where the cord color option is linked to Shopify's color swatches,
    snippets/kd-cord-swatches.liquid draws round photo buttons in
    place of the menu. The menu stays in the page, hidden, and is
    still the real pick: a tap on a swatch clicks the matching menu
    option, so everything above runs as before. The ring and the
    color name show once the product holds data-kd-color-picked.
  - More Colors shows its 21 colors as photo chips (snippets/
    kd-native-options.liquid); a tap on a chip sets the hidden select.
  - v7 (KD 9/25): the circles sit five to a row and See More Color
    Options is an All 21 colors bar; the list is laid out like her
    Cord Color Options card (its rows are still [data-kd-chip]). The
    label line (p[data-kd-sw-status]) shows "Choose a color" until a
    pick, then the color's name without its code; after See More it
    names the color picked in the list, never "See More Color
    Options" (cordStatus below, run on every update and list pick).
  - v10 (KD 9/25): where the All 21 colors bar exists, a pick from
    the list closes the list at once (its row gets data-kd-shut and
    the swatch snippet's CSS folds it; the select keeps its value, so
    the Cord Color property and the label line are as before) and
    the page scrolls smoothly until the bar sits about 12px under
    the header (its height read at that moment, see headerCover).
    Closed after a pick, the bar shows the color's photo chip, its
    name, "Change color" and the chevron pointing right (dressBar).
    With See More Color Options already the pick, a tap on the bar
    only opens or closes the list: no click on the hidden menu, so
    no variant change, no reset, no scroll. A circle tap works as
    before and clears the closed state. Add to Cart with no color
    picked in a closed list opens it again. Listings without the bar
    keep the list as it was.
  SIZE BOX (KD 9/23, cord bracelets with no Size menu)
  - The snippet renders a "Need a different size?" tick box only on
    a bracelet with a cord option and no size or length option.
    Unticked, the order carries Size: Standard (fits most); ticked,
    the six sizes open and the size picked is sent, and Add to Cart
    stops until one is picked. Hidden (and not sent) if an option
    pick already asks for a size.
  SECOND BEAD COLOR (v8, KD 9/25, Let Them 8632171004066 only)
  - The snippet renders a required "Second Bead Color" dropdown
    (row data-kd-row="bead2") whose colors are the product's first
    bead color option values. The script moves that row into the
    option menus, right after the First Bead Color menu (also after
    every swap of variant-selects), keeps its pick, puts back the
    ids the theme's swap renames, and stops its change events at the
    row so the theme never reads it as an option. The pick is sent
    as Second Bead Color; Add to Cart, the sticky bar and Buy it now
    stop until one is picked ("Please choose a color.").
  SIZE MENUS (v9, KD 9/25: one clean size menu, no printed helpers)
  - A size menu is any option whose name holds "size" or "length"
    (Total Length Range after the size run), two values or more, not
    the cord color menu. Forced pick like the cord color menu: it
    reads "Choose a size" until the shopper clicks a size in it (flag
    data-kd-size-picked on product-info: |name|name| or * ), and Add
    to Cart, the sticky bar and Buy it now stop with "Please choose a
    size." (block 272's look). A ?variant= address naming a real
    variant (the form's id equals it) counts as picked. Quick view
    with a size not picked goes to the product page to pick it.
  - Fit card: on products tagged kd-1pull, kd-2pull, kd-cz or
    kd-extender the snippet renders a small i and a card, one
    sentence per tag. The script puts it at the end of the size
    menu's label (again after every swap of variant-selects). Hover
    or keyboard focus opens it, a tap or click on the i pins or
    closes it, Esc or a tap outside closes it, and it is kept on
    screen.
  - Second slider (kd-1pull only, a tick inside the card): writes
    Second slider: Yes, and the add then goes out as ONE /cart/add.js
    call with two items, the necklace and Second Slider (Necklace
    Add-on) at the same quantity with For: <necklace title> and
    _kd_addon_for: <necklace variant id> (section 7). Buy it now with
    the tick on adds both and goes to checkout. Removing a necklace
    line in the cart lowers its add-on line to match.
  - The typed-size line under the Custom Size type-in box shows only
    while that box does.
  QUICK VIEW (any page)
  - A custom pick in quick view cannot reach the cart without its
    word: Add to Cart sends the shopper to the product page with the
    same variant picked instead. A cord color menu not picked in
    quick view sends the shopper to the product page to pick it, and
    so does a product with a First Bead Color menu (v8), since the
    second color is picked on the product page.

  TO UNDO: delete the script line in layout/theme.liquid (and block
  kd_native_opts in templates/product.json).
================================================================*/
(function () {
  'use strict';
  if (window.kdNativeOptions) return;
  var KD = window.kdNativeOptions = { version: '11.0', list: [] };

  var PINK = 'var(--kd-word-pink, #C7447F)';
  var WORD_PROP = 'Your Word', CORD_PROP = 'Cord Color', SIZE_PROP = 'Custom Size';
  var GIFT_PROP = 'Gift?', GIFT_VAL = 'This is a gift';
  var MSG_PROP = 'Gift Message';
  var GIFTEE_PROP = 'Ship to Giftee?', GIFTEE_VAL = 'Shipping Directly to Giftee';
  var MSG_MAX = 250;
  var SB_PROP = 'Size', SB_STD = 'Standard (fits most)';
  var B2_PROP = 'Second Bead Color', B2_FIRST = 'first bead color';
  var SIZE_TEXT = 'Choose a size', SIZE_PICKED = 'data-kd-size-picked', SIZE_NOTE = 'Please choose a size.';
  var SLIDER_PROP = 'Second slider', SLIDER_VAL = 'Yes', FOR_PROP = 'For', FOR_KEY = '_kd_addon_for';
  var BUY = '.shopify-payment-button, shopify-buy-it-now-button, shopify-accelerated-checkout, [data-buy-it-now]';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  /* ------------------------------------------------------------
     1. TRIGGER RULES, on the picked value of every option,
        case-insensitive.
     SIZE:  a value in the custom size list, any value holding the
            whole word "size" or "sizing", an "Other..." value
            (also "g. OTHER(leave note)") outside Morse and colour
            options, a "Custom..." value in a size or length option.
     COLOR: See More Color Options, MORE Strand / Color Options,
            More Sizing / Bead Color Options, Request Color / Size,
            Color / Request Size, any
            value holding "bead color" or "strand", and an "Other..."
            or "Custom..." value in a colour-only option.
     WORD:  not a size pick, in a Morse/word option (or an option
            of another kind), and the value starts with "custom" or
            holds an N-M range followed by Letter, Letters, Ltters or
            Characters. A bare range never counts.
     Custom Size shows the over-the-hand dropdown (bracelets only)
     when the size pick holds "sizing" or is "Custom Size".
     ------------------------------------------------------------ */
  var SIZE_LIST = ['more sizing options', 'other', 'other (note)', 'other (pls note)',
    'other pls leave note', 'other leave note', 'other (leave note)', 'other - leave note',
    'other - note', 'other request', 'request color / size', 'color / request size',
    'custom size'];
  var COLOR_LIST = ['see more color options', 'see more colors', 'more strand / color options',
    'more sizing / bead color options', 'request color / size', 'color / request size'];
  var RX_SIZEWORD = /(^|[^a-z])siz(e|ing)([^a-z]|$)/;
  var RX_SIZING = /(^|[^a-z])sizing([^a-z]|$)/;
  var RX_OTHER = /^(?:[a-z][0-9]?\.\s*)?other(?![a-z])/;
  var RX_RANGE_WORD = /(\d+)\s*-\s*(\d+)\s*(letters?|ltters|characters)(?![a-z])/;
  var RX_RANGE = /(\d+)\s*-\s*(\d+)/;

  function norm(s) {
    return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function optionKind(name) {
    var n = norm(name);
    if (/morse|word|letter|character|selection/.test(n)) return 'word';
    if (/colou?r/.test(n) && !/siz|length/.test(n)) return 'color';
    if (/siz|length/.test(n)) return 'size';
    return 'other';
  }
  function classify(value, optionName) {
    var n = norm(value), kind = optionKind(optionName);
    var t = { word: false, size: false, color: false, oh: false, cap: 0 };
    var other = RX_OTHER.test(n);
    if (RX_SIZEWORD.test(n) || (SIZE_LIST.indexOf(n) > -1 && !other)) t.size = true;
    if (other) {
      if (kind === 'color') t.color = true;
      else if (kind !== 'word') t.size = true;
    }
    if (COLOR_LIST.indexOf(n) > -1 || n.indexOf('bead color') > -1 || n.indexOf('strand') > -1) t.color = true;
    if (n.indexOf('custom') === 0) {
      if (kind === 'size') t.size = true;
      if (kind === 'color') t.color = true;
    }
    if (!t.size && (kind === 'word' || kind === 'other') &&
        (n.indexOf('custom') === 0 || RX_RANGE_WORD.test(n))) {
      var m = n.match(RX_RANGE);
      t.word = true;
      t.cap = m ? Math.max(+m[1], +m[2]) : 24;
    }
    if (t.size && (RX_SIZING.test(n) || n === 'custom size')) t.oh = true;
    return t;
  }
  KD.classify = classify;

  /* ------------------------------------------------------------
     2. READING THE PICKS from the visible variant-selects
     ------------------------------------------------------------ */
  var RX_OPTNAME = /^options\[(.*)\](?:-[^\[\]]*)?$/;
  function visibleVS(scope) {
    if (!scope) return null;
    var list = scope.querySelectorAll('variant-selects');
    for (var i = 0; i < list.length; i++) {
      var vs = list[i];
      if (!vs.isConnected || vs.style.display === 'none') continue;
      if (vs.closest('cart-bar, .cart-bar, [data-cart-bar]')) continue;
      return vs;
    }
    return null;
  }
  function readPicks(vs) {
    var out = [], seen = {};
    if (!vs) return out;
    var fields = vs.querySelectorAll('[data-popout-input], select, input[type="radio"]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i], nm = f.getAttribute('name') || '';
      if (f.closest('[data-kd-row]')) continue;
      var m = nm.match(RX_OPTNAME);
      var optName = m ? m[1] : '';
      var key = optName || nm || ('opt' + i);
      if (f.type === 'radio') {
        if (!seen[key]) { seen[key] = { name: optName, value: '', values: [] }; out.push(seen[key]); }
        seen[key].values.push(f.value);
        if (f.checked) seen[key].value = f.value;
        continue;
      }
      if (seen[key]) continue;
      var values = [];
      if (f.tagName === 'SELECT') {
        for (var j = 0; j < f.options.length; j++) values.push(f.options[j].value);
      } else {
        var wrap = f.closest('[data-selector-wrapper], .selector-wrapper, popout-select') || f.parentNode;
        var opts = wrap ? wrap.querySelectorAll('[data-popout-option]') : [];
        for (var k = 0; k < opts.length; k++) {
          values.push(opts[k].getAttribute('data-value') || (opts[k].textContent || '').trim());
        }
      }
      seen[key] = { name: optName, value: f.value, values: values };
      out.push(seen[key]);
    }
    return out;
  }
  function evaluate(picks) {
    var s = { word: false, cap: 0, maxCap: 0, size: false, oh: false, color: false };
    for (var i = 0; i < picks.length; i++) {
      var p = picks[i], t = classify(p.value, p.name);
      if (t.size) s.size = true;
      if (t.oh) s.oh = true;
      if (t.color) s.color = true;
      if (t.word && !s.word) {
        var mx = t.cap;
        for (var j = 0; j < p.values.length; j++) {
          var u = classify(p.values[j], p.name);
          if (u.word && u.cap > mx) mx = u.cap;
        }
        s.word = true; s.cap = t.cap; s.maxCap = mx;
      }
    }
    return s;
  }
  KD.readPicks = readPicks;
  KD.evaluate = evaluate;

  /* the listing's cord color menu, and whether the shopper has
     picked in it (a flag on the product-info that holds it, which
     outlives the theme's swaps of variant-selects) */
  var PICK_TEXT = 'Choose a color', PICKED = 'data-kd-color-picked';
  var RX_CORDVAL = /(^|[^a-z])cord([^a-z]|$)/;
  function cordMenu(vs) {
    if (!vs) return null;
    var pops = vs.querySelectorAll('popout-select');
    for (var i = 0; i < pops.length; i++) {
      var inp = pops[i].querySelector('[data-popout-input]');
      var m = inp ? (inp.getAttribute('name') || '').match(RX_OPTNAME) : null;
      if (!m) continue;
      var opts = pops[i].querySelectorAll('[data-popout-option]');
      if (opts.length < 2) continue;
      var cordish = /cord/i.test(m[1]);
      if (!cordish && optionKind(m[1]) === 'color') {
        for (var j = 0; j < opts.length; j++) {
          var v = norm(opts[j].getAttribute('data-value'));
          if (RX_CORDVAL.test(v) || v === 'see more color options' || v === 'see more colors') { cordish = true; break; }
        }
      }
      if (cordish) return { pop: pops[i], name: m[1], toggle: pops[i].querySelector('[data-popout-toggle]'), text: pops[i].querySelector('[data-popout-text]') };
    }
    return null;
  }
  function holderOf(el) {
    return el.closest('[data-quick-view-item]') || el.closest('product-info') || el.closest('.popup-quick-view') || document.body;
  }
  function picked(holder) { return !!holder && holder.hasAttribute(PICKED); }
  function swRow(pop) {
    var fs = pop && pop.parentNode;
    return fs ? fs.querySelector('[data-kd-sw]') : null;
  }
  function isMoreVal(v) {
    var n = norm(v);
    return n === 'see more color options' || n === 'see more colors' || n.indexOf('more strand') > -1;
  }
  /* a color's name without its card code: Warm Sand (N1) > Warm Sand */
  function shortName(v) {
    var s = String(v == null ? '' : v), i = s.lastIndexOf(' (');
    return i > 0 && s.charAt(s.length - 1) === ')' ? s.slice(0, i) : s;
  }
  /* the label line of the swatch row: "Choose a color" until there is
     a name to show (the CSS shows the name once the product holds
     data-kd-color-picked and the line carries kd-sw-status--has) */
  function setStatus(st, name) {
    var disp = shortName(name), nm = st.querySelector('.kd-sw-status__name');
    if (nm && nm.textContent !== disp) nm.textContent = disp;
    st.classList.toggle('kd-sw-status--has', !!disp);
  }
  /* a tap on a swatch (snippets/kd-cord-swatches.liquid) clicks the
     matching option of the hidden menu next to it */
  function pickSwatch(sw) {
    var row = sw.closest('[data-kd-sw]'), fs = row && row.parentNode;
    var pop = fs ? fs.querySelector('popout-select') : null;
    if (!pop) return;
    var val = sw.getAttribute('data-kd-sw-value') || '';
    var btns = row.querySelectorAll('[data-kd-sw-value]');
    for (var i = 0; i < btns.length; i++) btns[i].setAttribute('aria-checked', btns[i] === sw ? 'true' : 'false');
    var st = fs.querySelector('[data-kd-sw-status]');
    if (st) setStatus(st, isMoreVal(val) ? '' : val);
    var opts = pop.querySelectorAll('[data-popout-option]');
    for (var j = 0; j < opts.length; j++) {
      if (opts[j].getAttribute('data-value') === val) { opts[j].click(); return; }
    }
  }
  KD.cordMenu = cordMenu;
  /* v10: the height a sticky or fixed header covers at the top of the
     screen, read at the moment of the scroll (the live header is not
     sticky and scrolls away, so this is 0 there today) */
  function headerCover() {
    var list = document.querySelectorAll('.shopify-section-header, .header-group, header-component, [data-site-header], sticky-header');
    var cover = 0;
    for (var i = 0; i < list.length; i++) {
      var el = list[i], cs = getComputedStyle(el), b = el.getBoundingClientRect();
      if (!b.height || cs.display === 'none' || cs.visibility === 'hidden') continue;
      if (cs.position === 'fixed' && b.top <= 1 && b.bottom > 0) cover = Math.max(cover, b.bottom);
      else if (cs.position === 'sticky') cover = Math.max(cover, (parseFloat(cs.top) || 0) + b.height);
    }
    return Math.min(cover, window.innerHeight / 2);
  }
  /* smooth scroll until el's top (or the given top, in screen
     coordinates) sits about 12px under the header */
  function scrollUnder(el, top) {
    if (!el) return;
    var t = typeof top === 'number' ? top : el.getBoundingClientRect().top;
    var y = Math.max(0, Math.round(window.pageYOffset + t - headerCover() - 12));
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); }
  }
  KD.headerCover = headerCover;
  KD.scrollUnder = scrollUnder;

  /* size menus (v9): an option named with "size" or "length", two
     values or more, not the cord color menu. Picks are flagged per
     option name on the holder, which outlives the theme's swaps */
  var RX_SIZENAME = /size|length/i;
  function sizeMenus(vs) {
    var out = [];
    if (!vs) return out;
    var cm = cordMenu(vs), pops = vs.querySelectorAll('popout-select'), i, m;
    for (i = 0; i < pops.length; i++) {
      var inp = pops[i].querySelector('[data-popout-input]');
      m = inp ? (inp.getAttribute('name') || '').match(RX_OPTNAME) : null;
      if (!m || !RX_SIZENAME.test(m[1]) || (cm && cm.pop === pops[i]) || pops[i].closest('[data-kd-row]')) continue;
      if (pops[i].querySelectorAll('[data-popout-option]').length < 2) continue;
      var fs = pops[i].parentNode;
      out.push({ pop: pops[i], key: norm(m[1]), toggle: pops[i].querySelector('[data-popout-toggle]'), text: pops[i].querySelector('[data-popout-text]'), label: fs ? fs.querySelector('.select__label') : null });
    }
    var sets = vs.querySelectorAll('fieldset');
    for (i = 0; i < sets.length; i++) {
      var r = sets[i].querySelectorAll('input[type="radio"]');
      m = r.length > 1 ? (r[0].getAttribute('name') || '').match(RX_OPTNAME) : null;
      if (!m || !RX_SIZENAME.test(m[1]) || sets[i].closest('[data-kd-row]')) continue;
      out.push({ set: sets[i], key: norm(m[1]), toggle: r[0], label: sets[i].querySelector('legend') });
    }
    return out;
  }
  function sizePicked(holder, key) {
    var v = holder ? holder.getAttribute(SIZE_PICKED) : null;
    return v != null && (v === '*' || v.indexOf('|' + key + '|') > -1);
  }
  function markSize(holder, key) {
    if (!holder || sizePicked(holder, key)) return;
    holder.setAttribute(SIZE_PICKED, (holder.getAttribute(SIZE_PICKED) || '|') + key + '|');
  }
  function sizeNote(sm, bad) {
    var host = sm.pop ? sm.pop.parentNode : sm.set, note = host ? host.querySelector('.kd-pick-note') : null;
    if (bad && host && !note) {
      note = document.createElement('p');
      note.className = 'kd-pick-note';
      note.setAttribute('aria-live', 'polite');
      note.textContent = SIZE_NOTE;
      note.style.setProperty('color', PINK, 'important');
      note.style.setProperty('-webkit-text-fill-color', PINK, 'important');
      if (sm.pop) sm.pop.insertAdjacentElement('afterend', note); else host.appendChild(note);
    } else if (!bad && note) note.parentNode.removeChild(note);
  }
  /* a click on a size in its menu counts as the pick */
  function pickSize(pop, opt) {
    var list = pop ? sizeMenus(pop.closest('variant-selects')) : [];
    for (var i = 0; i < list.length; i++) {
      var sm = list[i];
      if (sm.pop !== pop) continue;
      markSize(holderOf(pop), sm.key);
      pop.classList.remove('kd-pick-needed', 'kd-pick-bad');
      if (sm.toggle) sm.toggle.removeAttribute('aria-invalid');
      sizeNote(sm, false);
      if (sm.text && sm.text.textContent === SIZE_TEXT) sm.text.textContent = opt.getAttribute('data-value') || '';
    }
  }
  KD.sizeMenus = sizeMenus;

  /* ------------------------------------------------------------
     3. COUNTING: letters and digits count one, spaces and
        punctuation are free, emoji and symbols are refused
     ------------------------------------------------------------ */
  var CH = String.fromCharCode;
  var TYPO = CH(0x2018) + CH(0x2019) + CH(0x201C) + CH(0x201D) + CH(0x2013) + CH(0x2014) + CH(0x2026);
  var RX_JOINERS = new RegExp('[' + CH(0xFE00) + '-' + CH(0xFE0F) + CH(0x200D) + ']', 'g');
  var RX_LETTER, RX_OK;
  try {
    RX_LETTER = new RegExp('[\\p{L}\\p{N}]', 'gu');
    RX_OK = new RegExp('^[\\p{L}\\p{N}\\p{Mn}\\p{Mc}\\s.,!?\'"&:;/()+#@*_' + TYPO + '\\-]$', 'u');
  } catch (e) {
    var LAT = CH(0xC0) + '-' + CH(0x24F);
    RX_LETTER = new RegExp('[A-Za-z0-9' + LAT + ']', 'g');
    RX_OK = new RegExp('^[A-Za-z0-9' + LAT + '\\s.,!?\'"&:;/()+#@*_' + TYPO + '\\-]$');
  }
  function count(s) {
    var m = String(s || '').match(RX_LETTER);
    return m ? m.length : 0;
  }
  function isCounted(ch) {
    RX_LETTER.lastIndex = 0;
    var r = RX_LETTER.test(ch);
    RX_LETTER.lastIndex = 0;
    return r;
  }
  function cleanWord(s) {
    var src = String(s || '').replace(RX_JOINERS, ''), out = '', refused = false;
    var chars = Array.from ? Array.from(src) : src.split('');
    for (var i = 0; i < chars.length; i++) {
      if (RX_OK.test(chars[i])) out += chars[i]; else refused = true;
    }
    return { text: out, refused: refused || src !== String(s || '') };
  }
  function trimToCap(s, cap) {
    var out = '', n = 0, chars = Array.from ? Array.from(s) : s.split('');
    for (var i = 0; i < chars.length; i++) {
      if (isCounted(chars[i])) { if (n < cap) { out += chars[i]; n++; } }
      else out += chars[i];
    }
    return out;
  }
  function tidy(s) {
    return String(s || '').replace(/\s+/g, ' ').trim();
  }
  KD.count = count;
  KD.cleanWord = cleanWord;

  /* ------------------------------------------------------------
     4. THE PRODUCT PAGE FIELDS
     ------------------------------------------------------------ */
  function show(el, on) { if (el) { if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); } }
  function isShown(el) { return !!el && !el.hasAttribute('hidden'); }
  function visible(el) { return !!el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  function Opts(root) {
    var q = function (sel) { return root.querySelector(sel); };
    this.root = root;
    this.pi = root.closest('product-info') || root.closest('section') || document.body;
    this.formId = root.getAttribute('data-form-id') || '';
    this.rows = { word: q('[data-kd-row="word"]'), cord: q('[data-kd-row="cord"]'), size: q('[data-kd-row="size"]'), gift: q('[data-kd-row="gift"]'), sizebox: q('[data-kd-row="sizebox"]'), bead2: q('[data-kd-row="bead2"]') };
    this.f = {
      word: q('[data-kd-field="word"]'), cord: q('[data-kd-field="cord"]'),
      size: q('[data-kd-field="size"]'), ohsize: q('[data-kd-field="ohsize"]'),
      gift: q('[data-kd-field="gift"]'), msg: q('[data-kd-field="msg"]'), giftee: q('[data-kd-field="giftee"]'),
      sizebox: q('[data-kd-field="sizebox"]'), sbsize: q('[data-kd-field="sbsize"]'),
      bead2: q('[data-kd-field="bead2"]'), slider: q('[data-kd-field="slider"]')
    };
    this.fit = q('[data-kd-fit-wrap]');
    this.fitI = q('[data-kd-fit-i]');
    this.fitCard = q('[data-kd-fit-card]');
    this.sizeHelp = q('[data-kd-size-help]');
    this.sizes = [];
    this.giftBody = q('[data-kd-gift-body]');
    this.sbBody = q('[data-kd-sizebox-body]');
    this.stash = {};
    this.state = { word: false, cap: 0, maxCap: 0, size: false, oh: false, color: false };
    this.prevWord = '';
    this.tried = false;
    this.shut = false;
    this.bar = null;
    this.refused = false;
    this.styled = false;
    this.propsKey = '';
    this.qv = !!root.closest('.popup-quick-view, [data-quick-view-item]');
    this.gap = 0;
    this.wordNext = this.rows.word ? this.rows.word.nextElementSibling : null;
    this.wordIds = [];
    if (this.rows.word) {
      var wid = this.rows.word.querySelectorAll('[id]');
      for (var k = 0; k < wid.length; k++) this.wordIds.push([wid[k], wid[k].id]);
    }
    root.kdOpts = this;
    try { if (/[?&]variant=\d/.test(window.location.search) && this.pi !== document.body) this.pi.setAttribute(PICKED, '1'); } catch (e) {}
    try {
      var vm = window.location.search.match(/[?&]variant=(\d+)/), fm = this.form(), idIn = fm ? fm.querySelector('[name="id"]') : null;
      if (vm && idIn && String(idIn.value) === vm[1] && this.pi !== document.body) this.pi.setAttribute(SIZE_PICKED, '*');
    } catch (e) {}
    this.bind();
  }
  Opts.prototype.form = function () {
    var f = this._form;
    if (f && f.isConnected) return f;
    f = this.formId ? document.getElementById(this.formId) : null;
    if (!f || f.tagName !== 'FORM') f = this.pi.querySelector('form[data-product-form]');
    this._form = f;
    return f;
  };
  Opts.prototype.bind = function () {
    var self = this, f = this.f;
    var stop = function (e) { e.stopPropagation(); };
    this.root.addEventListener('input', stop);
    this.root.addEventListener('change', stop);
    if (this.rows.bead2) {
      this.rows.bead2.addEventListener('input', stop);
      this.rows.bead2.addEventListener('change', stop);
    }
    if (this.rows.word) {
      this.rows.word.addEventListener('input', stop);
      this.rows.word.addEventListener('change', stop);
    }
    if (f.word) {
      f.word.addEventListener('input', function () { self.onWordInput(); });
      f.word.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); f.word.blur(); } });
      f.word.addEventListener('blur', function () { var v = tidy(f.word.value); if (v !== f.word.value) { f.word.value = v; self.prevWord = v; } self.sync(); });
    }
    [f.size].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', function () { self.afterEdit(); });
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); el.blur(); } });
    });
    [f.cord, f.ohsize, f.sbsize, f.bead2].forEach(function (el) {
      if (el) el.addEventListener('change', function () { self.afterEdit(); });
    });
    if (f.sizebox) f.sizebox.addEventListener('change', function () { self.onSizebox(); });
    if (f.gift) f.gift.addEventListener('change', function () { self.onGift(); });
    if (f.giftee) f.giftee.addEventListener('change', function () { self.sync(); });
    if (f.msg) f.msg.addEventListener('input', function () { self.onMsg(); });
    if (this.fit) this.bindFit();
  };
  /* the fit card (v9): hover or keyboard focus opens it, a click or
     tap on the i pins it open or closes it, Esc closes it */
  Opts.prototype.bindFit = function () {
    var self = this, w = this.fit, i = this.fitI, timer = 0, pointer = 0, hover = false;
    var stop = function (e) { e.stopPropagation(); };
    w.addEventListener('input', stop);
    w.addEventListener('change', stop);
    if (this.f.slider) this.f.slider.addEventListener('change', function () { self.sync(); });
    if (!i) return;
    try { hover = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}
    w.addEventListener('mouseenter', function () { if (!hover) return; clearTimeout(timer); if (!self.fitOpen) self.openFit(false); });
    w.addEventListener('mouseleave', function () {
      if (!hover) return;
      clearTimeout(timer);
      timer = setTimeout(function () { if (self.fitOpen && !self.fitPinned && !w.contains(document.activeElement)) self.openFit(null); }, 200);
    });
    var down = function () { pointer = Date.now(); };
    i.addEventListener('pointerdown', down);
    i.addEventListener('mousedown', down);
    i.addEventListener('touchstart', down, { passive: true });
    i.addEventListener('focus', function () { if (Date.now() - pointer > 600 && !self.fitOpen) self.openFit(false); });
    i.addEventListener('click', function (e) { e.preventDefault(); if (self.fitOpen && self.fitPinned) self.openFit(null); else self.openFit(true); });
    w.addEventListener('focusout', function (e) {
      if (e.relatedTarget && w.contains(e.relatedTarget)) return;
      setTimeout(function () {
        var over = false;
        try { over = hover && w.matches(':hover'); } catch (x) {}
        if (self.fitOpen && !w.contains(document.activeElement) && !over) self.openFit(null);
      }, 0);
    });
    w.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.fitOpen) { e.preventDefault(); self.openFit(null); pointer = Date.now(); i.focus(); } });
  };
  Opts.prototype.openFit = function (pin) {
    var c = this.fitCard, i = this.fitI, on = pin !== null;
    if (!c || !i) return;
    this.fitOpen = on;
    this.fitPinned = !!pin;
    show(c, on);
    i.setAttribute('aria-expanded', on ? 'true' : 'false');
    this.fit.classList.toggle('kd-fit--open', on);
    if (on) this.fitEdge();
  };
  /* keeps the card on screen: it shifts by whatever spills past an
     8px edge of the window */
  Opts.prototype.fitEdge = function () {
    var c = this.fitCard;
    c.style.left = '';
    var r = c.getBoundingClientRect(), vw = document.documentElement.clientWidth || window.innerWidth || 0, dx = 0;
    if (!r.width || !vw) return;
    if (r.right > vw - 8) dx = vw - 8 - r.right;
    if (r.left + dx < 8) dx = 8 - r.left;
    if (dx) c.style.left = Math.round(dx) + 'px';
  };
  /* the i and its card go at the end of the first size menu's label;
     with no size menu they wait, hidden, in the fields box */
  Opts.prototype.placeFit = function () {
    var w = this.fit;
    if (!w) return;
    var sm = this.sizes[0], host = sm ? sm.label : null;
    if (!host) {
      if (this.fitOpen) this.openFit(null);
      show(w, false);
      if (w.parentNode !== this.root) this.root.appendChild(w);
      return;
    }
    if (w.parentNode !== host || host.lastElementChild !== w) host.appendChild(w);
    show(w, true);
    var ids = w.querySelectorAll('[data-kd-id]');
    for (var j = 0; j < ids.length; j++) {
      var id = ids[j].getAttribute('data-kd-id');
      if (id && ids[j].id !== id) ids[j].id = id;
    }
  };
  Opts.prototype.sliderOn = function () {
    var t = this.f.slider;
    return !!t && t.checked && !!t.getAttribute('data-kd-addon-vid') && !!this.fit && isShown(this.fit);
  };
  Opts.prototype.dressSizes = function () {
    var list = this.sizes;
    for (var i = 0; i < list.length; i++) {
      var sm = list[i], el = sm.pop || sm.set;
      if (!el || !el.isConnected) continue;
      var need = !sizePicked(this.pi, sm.key), bad = need && this.tried;
      el.classList.toggle('kd-pick-needed', need);
      el.classList.toggle('kd-pick-bad', bad);
      if (need && sm.text && sm.text.textContent !== SIZE_TEXT) sm.text.textContent = SIZE_TEXT;
      if (sm.toggle) { if (bad) sm.toggle.setAttribute('aria-invalid', 'true'); else sm.toggle.removeAttribute('aria-invalid'); }
      sizeNote(sm, bad);
    }
  };
  Opts.prototype.place = function () {
    var root = this.root, vs = visibleVS(this.pi);
    if (vs && vs.parentNode) {
      var after = vs.parentNode === root.parentNode && (vs.compareDocumentPosition(root) & 4);
      if (!after) vs.insertAdjacentElement('afterend', root);
    } else {
      var pf = this.pi.querySelector('.product__form');
      if (pf && root.parentNode !== pf) pf.insertBefore(root, pf.firstChild);
    }
    root.classList.add('kd-opts--on');
    this.placeB2(vs);
    this.placeWord(vs);
    return vs;
  };
  /* WB1 (KD 10/8): where a product has a menu named Morse Code, the
     Your Word row goes inside that menu's own cell (its
     .selector-wrapper), right under the menu, so it stays in that
     column of the menu grid on every screen. Re-placed on every
     update, since the theme swaps variant-selects on every pick, and
     the ids the swap renames are put back. Its change and input
     events stop at the row (bind), so the theme never reads it as an
     option. It carries the kd-opts classes there so block 270 styles
     it as before; the small style from wb1Css keeps it hidden while
     hidden and gives its label the menus' line height on phones. Its
     space above is the fields box gap (space). Products without a
     Morse Code menu, and quick view, keep it in the fields box. */
  var MORSE_MENU = 'morse code';
  function morseWrap(vs) {
    var wraps = vs ? vs.querySelectorAll('[data-selector-wrapper], .selector-wrapper') : [];
    for (var i = 0; i < wraps.length; i++) {
      if (wraps[i].closest('[data-kd-row]')) continue;
      var inp = wraps[i].querySelector('[data-popout-input], select, input[type="radio"]');
      var m = inp ? (inp.getAttribute('name') || '').match(RX_OPTNAME) : null;
      if (m && norm(m[1]) === MORSE_MENU) return wraps[i];
    }
    return null;
  }
  function wb1Css() {
    if (document.getElementById('kd-wb1-css')) return;
    var st = document.createElement('style');
    st.id = 'kd-wb1-css';
    st.textContent = '.kd-opts.kd-wb1[hidden] { display: none !important; } ' +
      '@media only screen and (max-width: 767px) { .kd-opts.kd-opts__row--word.kd-wb1 .kd-opts__label { line-height: 1.1; } }';
    (document.head || document.documentElement).appendChild(st);
  }
  Opts.prototype.placeWord = function (vs) {
    var row = this.rows.word;
    if (!row) return;
    var cell = this.qv ? null : morseWrap(vs);
    if (cell) {
      if (!row.classList.contains('kd-wb1')) { wb1Css(); row.classList.add('kd-opts', 'kd-opts--on', 'kd-wb1'); }
      if (row.parentNode !== cell) cell.appendChild(row);
      var mt = (this.gap || 12) + 'px';
      if (row.style.getPropertyValue('margin-top') !== mt) row.style.setProperty('margin-top', mt, 'important');
    } else if (row.parentNode !== this.root) {
      row.classList.remove('kd-opts', 'kd-opts--on', 'kd-wb1');
      row.style.removeProperty('margin-top');
      this.root.insertBefore(row, this.wordNext && this.wordNext.parentNode === this.root ? this.wordNext : null);
    }
    for (var j = 0; j < this.wordIds.length; j++) {
      var w = this.wordIds[j];
      if (w[0].id !== w[1]) w[0].id = w[1];
    }
  };
  /* the Second Bead Color row goes right after the menu it pairs
     with (data-kd-after, the option the snippet read its colors
     from); with no such menu it stays first in the fields box */
  Opts.prototype.placeB2 = function (vs) {
    var row = this.rows.bead2;
    if (!row) return;
    var want = norm(row.getAttribute('data-kd-after')), anchor = null;
    var wraps = vs ? vs.querySelectorAll('[data-selector-wrapper], .selector-wrapper') : [];
    for (var i = 0; i < wraps.length && !anchor; i++) {
      var inp = wraps[i].querySelector('[data-popout-input], select, input[type="radio"]');
      var m = inp ? (inp.getAttribute('name') || '').match(RX_OPTNAME) : null;
      var nm = m ? norm(m[1]) : '';
      if (nm && (nm === want || nm === B2_FIRST)) anchor = wraps[i];
    }
    if (anchor) {
      if (anchor.nextElementSibling !== row) anchor.insertAdjacentElement('afterend', row);
    } else if (row.parentNode !== this.root) {
      this.root.insertBefore(row, this.root.firstChild);
    }
    var ids = row.querySelectorAll('[data-kd-id]');
    for (var j = 0; j < ids.length; j++) {
      var id = ids[j].getAttribute('data-kd-id');
      if (id && ids[j].id !== id) ids[j].id = id;
    }
  };
  Opts.prototype.update = function (force) {
    if (!this.root.isConnected) return;
    var vs = this.place();
    var picks = readPicks(vs);
    var sig = picks.map(function (p) { return p.name + '=' + p.value; }).join('|');
    if (!force && sig === this.sig && vs === this.vs) return;
    this.sig = sig;
    this.vs = vs;
    this.menu = cordMenu(vs);
    this.dressMenu();
    this.sizes = sizeMenus(vs);
    this.dressSizes();
    this.placeFit();
    var s = this.state = evaluate(picks);
    var f = this.f;
    this.toggle('word', s.word, [f.word]);
    this.toggle('cord', s.color, [f.cord]);
    if (!s.color) this.shut = false;
    var useOh = s.size && s.oh && !!f.ohsize;
    this.toggle('size', s.size, [useOh ? f.ohsize : f.size]);
    if (f.ohsize) {
      if (s.size && useOh) { this.swapField(f.size, f.ohsize); } else { this.swapField(f.ohsize, f.size); }
    }
    var lab = this.rows.size && this.rows.size.querySelector('label');
    if (lab) lab.setAttribute('for', (useOh ? f.ohsize : f.size).id);
    if (this.sizeHelp) show(this.sizeHelp, s.size && !useOh);
    if (this.rows.sizebox) show(this.rows.sizebox, !s.size);
    this.wordNote();
    this.fieldNotes();
    this.dress();
    this.sync();
    this.space(vs);
  };
  Opts.prototype.toggle = function (key, on, fields) {
    var row = this.rows[key];
    if (!row) return;
    var was = isShown(row);
    show(row, on);
    var self = this;
    fields.forEach(function (el) {
      if (!el) return;
      var k = el.getAttribute('data-kd-field');
      if (!on && was) { self.stash[k] = el.value; el.value = ''; }
      if (on && !was && !el.value && self.stash[k]) { el.value = self.stash[k]; }
    });
    if (key === 'word' && on && !was) this.prevWord = this.f.word ? this.f.word.value : '';
    if (key === 'word' && !on) this.emptyTried = false;
  };
  Opts.prototype.swapField = function (off, on) {
    if (off && isShown(off)) { this.stash[off.getAttribute('data-kd-field')] = off.value; off.value = ''; show(off, false); }
    if (on && !isShown(on)) { show(on, true); var k = on.getAttribute('data-kd-field'); if (!on.value && this.stash[k]) on.value = this.stash[k]; }
  };
  Opts.prototype.onWordInput = function () {
    var el = this.f.word, v = el.value, pos = el.selectionStart;
    var c = cleanWord(v);
    this.refused = c.text !== v;
    v = c.text;
    var cap = this.state.cap || 24, n = count(v);
    if (n > cap && n > count(this.prevWord)) v = trimToCap(v, Math.max(cap, count(this.prevWord)));
    if (v !== el.value) {
      var drop = el.value.length - v.length;
      el.value = v;
      try { var p = Math.max(0, Math.min(v.length, (pos || v.length) - drop)); el.setSelectionRange(p, p); } catch (e) {}
    }
    this.prevWord = v;
    if (count(v)) this.emptyTried = false;
    this.wordNote();
    this.sync();
  };
  Opts.prototype.afterEdit = function () {
    this.fieldNotes();
    this.dress();
    this.sync();
  };
  Opts.prototype.onGift = function () {
    var on = !!(this.f.gift && this.f.gift.checked);
    var f = this.f;
    show(this.giftBody, on);
    if (!on) {
      this.stash.msg = f.msg ? f.msg.value : ''; this.stash.giftee = f.giftee ? f.giftee.checked : false;
      if (f.msg) f.msg.value = '';
      if (f.giftee) f.giftee.checked = false;
    } else {
      if (f.msg && !f.msg.value && this.stash.msg) f.msg.value = this.stash.msg;
      if (f.giftee && this.stash.giftee) f.giftee.checked = true;
    }
    this.onMsg();
    this.space();
  };
  Opts.prototype.onSizebox = function () {
    var on = !!(this.f.sizebox && this.f.sizebox.checked), el = this.f.sbsize;
    show(this.sbBody, on);
    if (el) {
      if (!on) { this.stash.sbsize = el.value; el.value = ''; }
      else if (!el.value && this.stash.sbsize) el.value = this.stash.sbsize;
    }
    this.afterEdit();
    this.space();
  };
  Opts.prototype.sizeboxOn = function () {
    return !!this.rows.sizebox && isShown(this.rows.sizebox);
  };
  Opts.prototype.onMsg = function () {
    var f = this.f.msg;
    if (!f) return;
    if (f.value.length > MSG_MAX) f.value = f.value.slice(0, MSG_MAX);
    var note = document.getElementById(f.getAttribute('aria-describedby'));
    if (note) note.textContent = f.value.length + '/' + MSG_MAX;
    this.sync();
  };
  Opts.prototype.note = function (key) {
    var row = this.rows[key];
    return row ? row.querySelector('.kd-opts__note') : null;
  };
  Opts.prototype.setNote = function (key, text, bad, field) {
    var n = this.note(key);
    if (n) {
      if (n.textContent !== text) n.textContent = text;
      n.classList.toggle('kd-opts__note--bad', !!bad);
      if (bad) { n.style.setProperty('color', PINK, 'important'); n.style.setProperty('-webkit-text-fill-color', PINK, 'important'); }
      else { n.style.removeProperty('color'); n.style.removeProperty('-webkit-text-fill-color'); }
    }
    if (field) {
      var hard = bad === 1;
      field.classList.toggle('kd-opts__input--bad', hard);
      if (hard) field.setAttribute('aria-invalid', 'true'); else field.removeAttribute('aria-invalid');
    }
  };
  Opts.prototype.wordNote = function () {
    var el = this.f.word, s = this.state;
    if (!el || !s.word) { this.setNote('word', '', 0, el); return; }
    var n = count(el.value), cap = s.cap, max = s.maxCap || cap;
    if (this.refused) {
      this.setNote('word', 'Letters and numbers only. Emoji and symbols can\'t be spelled in Morse.', n > cap ? 1 : 2, el);
    } else if (!n && this.emptyTried) {
      this.setNote('word', 'Please type your word first.', 1, el);
    } else if (n > cap) {
      this.setNote('word', max > cap && n <= max ?
        'Your word has ' + n + ' letters. Choose a bigger letter count above, or shorten it.' :
        'Your word has ' + n + ' letters. ' + Math.max(cap, max) + ' is the most we can fit.', 1, el);
    } else if (n === cap) {
      this.setNote('word', n + ' of ' + cap + ' letters used. ' + (cap >= max ? 'That is the most we can fit.' : 'For a longer word, choose a bigger letter count above.'), 2, el);
    } else if (n) {
      this.setNote('word', n + ' of ' + cap + ' letters used. Spaces are free.', 0, el);
    } else {
      this.setNote('word', 'Up to ' + cap + ' letters. Spaces are free.', 0, el);
    }
  };
  Opts.prototype.fieldNotes = function () {
    var f = this.f, s = this.state, tried = this.tried;
    var cordBad = s.color && tried && f.cord && !f.cord.value;
    this.setNote('cord', cordBad ? 'Please choose a color.' : '', cordBad ? 1 : 0, f.cord);
    var sizeEl = s.size && s.oh && f.ohsize ? f.ohsize : f.size;
    var other = sizeEl === f.size ? f.ohsize : f.size;
    if (other) other.classList.remove('kd-opts__input--bad');
    var sizeBad = s.size && tried && sizeEl && !tidy(sizeEl.value);
    this.setNote('size', sizeBad ? (sizeEl === f.ohsize ? 'Please choose your size.' : 'Please type your size.') : '', sizeBad ? 1 : 0, sizeEl);
    if (this.rows.sizebox) {
      var sbBad = this.sizeboxOn() && tried && f.sizebox && f.sizebox.checked && f.sbsize && !f.sbsize.value;
      this.setNote('sizebox', sbBad ? 'Please choose your size.' : '', sbBad ? 1 : 0, f.sbsize);
    }
    if (this.rows.bead2) {
      var b2Bad = tried && f.bead2 && !f.bead2.value;
      this.setNote('bead2', b2Bad ? 'Please choose a color.' : '', b2Bad ? 1 : 0, f.bead2);
    }
  };
  Opts.prototype.dressMenu = function () {
    var m = this.menu;
    if (!m || !m.pop.isConnected) return;
    var need = !picked(this.pi), bad = need && this.tried;
    m.pop.classList.toggle('kd-pick-needed', need);
    m.pop.classList.toggle('kd-pick-bad', bad);
    if (need && m.text && m.text.textContent !== PICK_TEXT) m.text.textContent = PICK_TEXT;
    if (m.toggle) { if (bad) m.toggle.setAttribute('aria-invalid', 'true'); else m.toggle.removeAttribute('aria-invalid'); }
    var host = m.pop.parentNode, note = host ? host.querySelector('.kd-pick-note') : null;
    if (bad && host && !note) {
      note = document.createElement('p');
      note.className = 'kd-pick-note';
      note.setAttribute('aria-live', 'polite');
      note.textContent = 'Please choose a color.';
      note.style.setProperty('color', PINK, 'important');
      note.style.setProperty('-webkit-text-fill-color', PINK, 'important');
      m.pop.insertAdjacentElement('afterend', note);
    } else if (!bad && note) note.parentNode.removeChild(note);
  };
  Opts.prototype.dress = function () {
    var f = this.f;
    this.chips();
    [f.cord, f.ohsize, f.sbsize, f.bead2].forEach(function (el) { if (el) el.classList.toggle('kd-opts__select--empty', !el.value); });
    if (this.styled) return;
    var vs = visibleVS(this.pi), t = vs && vs.querySelector('.select-popout__toggle, select');
    if (!t || !visible(t)) return;
    var cs = getComputedStyle(t), src = cs;
    if (!parseFloat(cs.borderTopWidth) && t.parentElement) src = getComputedStyle(t.parentElement);
    var els = [].slice.call(this.root.querySelectorAll('.kd-opts__input'));
    if (f.bead2 && els.indexOf(f.bead2) < 0) els.push(f.bead2);
    if (f.word && els.indexOf(f.word) < 0) els.push(f.word);
    for (var i = 0; i < els.length; i++) {
      var st = els[i].style;
      ['Top', 'Right', 'Bottom', 'Left'].forEach(function (side) {
        ['Width', 'Style', 'Color'].forEach(function (p) { st['border' + side + p] = src['border' + side + p]; });
      });
      st.borderRadius = src.borderRadius;
      st.backgroundColor = src.backgroundColor;
      ['fontFamily', 'fontWeight', 'letterSpacing', 'color', 'paddingLeft', 'paddingRight'].forEach(function (p) { st[p] = cs[p]; });
      if (els[i].tagName !== 'TEXTAREA' && t.offsetHeight > 30) st.minHeight = t.offsetHeight + 'px';
    }
    this.styled = true;
  };
  Opts.prototype.chips = function () {
    var f = this.f.cord, list = this.root.querySelectorAll('[data-kd-chip]');
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute('aria-pressed', f && list[i].getAttribute('data-kd-chip') === f.value ? 'true' : 'false');
    }
    this.cordStatus();
  };
  Opts.prototype.cordStatus = function () {
    this.dressBar();
    var m = this.menu, st = m && m.pop.isConnected && m.pop.parentNode ? m.pop.parentNode.querySelector('[data-kd-sw-status]') : null;
    if (!st) return;
    var inp = m.pop.querySelector('[data-popout-input]'), val = inp ? inp.value : '';
    var f = this.f.cord, s = this.state, more = isMoreVal(val);
    setStatus(st, more ? (s.color && f && f.value ? f.value : '') : val);
    st.classList.toggle('kd-sw-status--bad', !!(this.tried && more && s.color && f && !f.value));
  };
  /* v10: the All 21 colors bar and the list's row, open or closed.
     Run on every update (the theme redraws the bar on every swap)
     and after a list pick or a bar tap. */
  Opts.prototype.dressBar = function () {
    var m = this.menu, row = m && m.pop.isConnected ? swRow(m.pop) : null;
    var bar = this.bar = row ? row.querySelector('.kd-sw__bar') : null;
    var f = this.f.cord, shut = !!(bar && this.shut && this.state.color), has = shut && !!(f && f.value);
    var r = this.rows.cord;
    if (r) { if (shut) r.setAttribute('data-kd-shut', ''); else r.removeAttribute('data-kd-shut'); }
    if (!bar) return;
    bar.classList.toggle('kd-sw__bar--shut', shut);
    bar.classList.toggle('kd-sw__bar--has', has);
    var nm = bar.querySelector('.kd-sw__pname'), ch = bar.querySelector('.kd-sw__chip');
    var name = has ? shortName(f.value) : '';
    if (nm && nm.textContent !== name) nm.textContent = name;
    if (ch) {
      var bg = '', list = has ? this.root.querySelectorAll('[data-kd-chip]') : [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('data-kd-chip') === f.value) { var sw = list[i].querySelector('.kd-cl__sw'); bg = sw ? sw.style.backgroundImage : ''; break; }
      }
      if (ch.style.backgroundImage !== bg) ch.style.backgroundImage = bg;
    }
  };
  /* v10: true when a tap on this bar should only open or close the
     list: See More Color Options is already the shopper's pick */
  Opts.prototype.barIsPick = function (bar) {
    this.update();
    var m = this.menu, row = m && m.pop.isConnected ? swRow(m.pop) : null;
    var inp = row && row.contains(bar) ? m.pop.querySelector('[data-popout-input]') : null;
    return !!inp && this.state.color && picked(holderOf(bar)) && isShown(this.rows.cord) &&
      inp.value === bar.getAttribute('data-kd-sw-value');
  };
  Opts.prototype.values = function () {
    var f = this.f, s = this.state, p = [];
    if (s.word && f.word) { var w = tidy(f.word.value); if (w) p.push([WORD_PROP, w]); }
    if (this.rows.bead2 && f.bead2 && f.bead2.value) p.push([B2_PROP, f.bead2.value]);
    if (s.color && f.cord && f.cord.value) p.push([CORD_PROP, f.cord.value]);
    if (s.size) {
      var el = s.oh && f.ohsize ? f.ohsize : f.size;
      var v = el ? tidy(el.value) : '';
      if (v) p.push([SIZE_PROP, v]);
    }
    if (this.sizeboxOn()) {
      if (f.sizebox && f.sizebox.checked) { if (f.sbsize && f.sbsize.value) p.push([SB_PROP, f.sbsize.value]); }
      else p.push([SB_PROP, SB_STD]);
    }
    if (this.sliderOn()) p.push([SLIDER_PROP, SLIDER_VAL]);
    if (f.gift && f.gift.checked) {
      p.push([GIFT_PROP, GIFT_VAL]);
      var m = f.msg ? String(f.msg.value).trim() : '';
      if (m) p.push([MSG_PROP, m.slice(0, MSG_MAX)]);
      if (f.giftee && f.giftee.checked) p.push([GIFTEE_PROP, GIFTEE_VAL]);
    }
    return p;
  };
  Opts.prototype.sync = function () {
    var form = this.form();
    if (!form) return;
    var p = this.values(), key = JSON.stringify(p);
    var box = form.querySelector('.kd-opts-props');
    if (box && key === this.propsKey) return;
    if (!box) { box = document.createElement('div'); box.className = 'kd-opts-props'; box.hidden = true; form.appendChild(box); }
    while (box.firstChild) box.removeChild(box.firstChild);
    p.forEach(function (kv) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'properties[' + kv[0] + ']'; i.value = kv[1];
      box.appendChild(i);
    });
    this.propsKey = key;
  };
  Opts.prototype.problem = function () {
    var f = this.f, s = this.state;
    if (this.menu && this.menu.pop.isConnected && !picked(this.pi)) return swRow(this.menu.pop) || this.menu.toggle || this.menu.pop;
    for (var z = 0; z < this.sizes.length; z++) {
      var sz = this.sizes[z], sel = sz.pop || sz.set;
      if (sel && sel.isConnected && !sizePicked(this.pi, sz.key)) return sz.toggle || sel;
    }
    if (this.rows.bead2 && f.bead2 && !f.bead2.value) return f.bead2;
    if (s.word && f.word) {
      var n = count(f.word.value);
      if (!n) { this.emptyTried = true; return f.word; }
      if (n > s.cap) return f.word;
    }
    if (s.color && f.cord && !f.cord.value) return this.root.querySelector('[data-kd-chips]') || f.cord;
    if (s.size) {
      var el = s.oh && f.ohsize ? f.ohsize : f.size;
      if (el && !tidy(el.value)) return el;
    }
    if (this.sizeboxOn() && f.sizebox && f.sizebox.checked && f.sbsize && !f.sbsize.value) return f.sbsize;
    return null;
  };
  Opts.prototype.attempt = function (e) {
    this.update(true);
    this.tried = true;
    var bad = this.problem();
    this.wordNote();
    this.fieldNotes();
    this.dressMenu();
    this.dressSizes();
    this.cordStatus();
    if (!bad) { this.sync(); return true; }
    if (this.shut && this.rows.cord && this.rows.cord.contains(bad)) { this.shut = false; this.cordStatus(); }
    e.preventDefault();
    e.stopImmediatePropagation();
    try { bad.scrollIntoView({ block: 'center', behavior: 'smooth' }); bad.focus({ preventScroll: true }); } catch (x) {}
    return false;
  };
  Opts.prototype.ownsForm = function (form) {
    var f = this.form();
    return !!form && !!f && form === f;
  };
  Opts.prototype.ownsButton = function (btn) {
    var f = this.form();
    if (btn.form && f) return btn.form === f;
    if (btn.closest('.popup-quick-view, [data-quick-view-item], [data-upsell-holder], [data-product-form-upsell], [data-quickbuy-form]')) return false;
    return this.pi.contains(btn);
  };
  Opts.prototype.space = function (vs) {
    var root = this.root;
    vs = vs || visibleVS(this.pi);
    if (!visible(root)) return;
    var rows = vs ? [].filter.call(vs.querySelectorAll('.selector-wrapper'), visible) : [];
    var gap = 12;
    if (rows.length > 1) {
      var g = rows[1].getBoundingClientRect().top - rows[0].getBoundingClientRect().bottom;
      if (g > 2 && g < 48) gap = Math.round(g * 10) / 10;
    }
    root.style.setProperty('--kd-opts-gap', gap + 'px');
    this.gap = gap;
    var wr = this.rows.word;
    if (wr && wr.classList.contains('kd-wb1') && wr.style.getPropertyValue('margin-top') !== gap + 'px') wr.style.setProperty('margin-top', gap + 'px', 'important');
    if (!rows.length) { root.style.removeProperty('margin-top'); return; }
    root.style.setProperty('margin-top', '0px', 'important');
    var low = rows[rows.length - 1].getBoundingClientRect().bottom, b2 = this.rows.bead2;
    if (b2 && vs && vs.contains(b2) && visible(b2)) low = Math.max(low, b2.getBoundingClientRect().bottom);
    var cur = root.getBoundingClientRect().top - low;
    var mt = Math.round((gap - cur) * 10) / 10;
    if (Math.abs(mt) >= 0.5) root.style.setProperty('margin-top', mt + 'px', 'important');
    else root.style.removeProperty('margin-top');
  };

  /* ------------------------------------------------------------
     5. QUICK VIEW: a pick that needs a field goes to the product
        page with the same variant picked
     ------------------------------------------------------------ */
  function quickView(e, el) {
    var item = el.closest('[data-quick-view-item]') || el.closest('.popup-quick-view');
    if (!item) return;
    var qvs = visibleVS(item), qp = readPicks(qvs), s = evaluate(qp);
    var menu = cordMenu(qvs), needColor = !!menu && !picked(holderOf(menu.pop));
    var needB2 = false;
    for (var k = 0; k < qp.length; k++) { if (norm(qp[k].name) === B2_FIRST) needB2 = true; }
    var needSize = false, qs = sizeMenus(qvs);
    for (var z = 0; z < qs.length; z++) { if (!sizePicked(holderOf(qs[z].pop || qs[z].set), qs[z].key)) needSize = true; }
    if (!(s.word || s.size || s.color || needColor || needB2 || needSize)) return;
    var pi = item.matches('product-info') ? item : (item.querySelector('product-info') || item);
    var url = pi.getAttribute('data-url') || '';
    if (!url) { var a = item.querySelector('a[href*="/products/"]'); url = a ? a.getAttribute('href') : ''; }
    if (!url) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = pi.querySelector('form[data-product-form]') || item.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var vid = idInput ? idInput.value : '';
    window.location.href = url.split('?')[0] + (vid && !needColor && !needSize ? '?variant=' + encodeURIComponent(vid) : '');
  }
  KD.quickView = quickView;

  /* ------------------------------------------------------------
     6. WIRING: capture listeners on document run before the
        theme's own add-to-cart handlers
     ------------------------------------------------------------ */
  var ADD = 'button[name="add"], [data-add-to-cart], [data-cart-bar-add-to-cart], .shopify-payment-button, shopify-buy-it-now-button, shopify-accelerated-checkout, [data-buy-it-now]';
  function each(fn) {
    for (var i = 0; i < KD.list.length; i++) {
      var o = KD.list[i];
      if (o.root.isConnected && fn(o) === false) return false;
    }
  }
  document.addEventListener('submit', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'FORM') return;
    var handled = false;
    each(function (o) { if (o.ownsForm(t)) { handled = true; if (!o.attempt(e)) return false; } });
    if (!handled && t.closest('.popup-quick-view, [data-quick-view-item]')) quickView(e, t);
  }, true);
  document.addEventListener('click', function (e) {
    each(function (o) { if (o.fitOpen && !o.fit.contains(e.target)) o.openFit(null); });
    var sw = e.target && e.target.closest ? e.target.closest('[data-kd-sw-value]') : null;
    if (sw) {
      e.preventDefault();
      var so = null;
      if (sw.classList.contains('kd-sw__bar')) each(function (o) { if (o.pi.contains(sw)) { so = o; return false; } });
      if (so && so.barIsPick(sw)) { so.shut = !so.shut; so.cordStatus(); return; }
      pickSwatch(sw);
      return;
    }
    var chip = e.target && e.target.closest ? e.target.closest('[data-kd-chip]') : null;
    if (chip) {
      e.preventDefault();
      var kr = chip.closest('[data-kd-opts]'), ko = kr && kr.kdOpts;
      if (ko && ko.f.cord) {
        var kf = false;
        try { kf = chip.matches(':focus-visible'); } catch (x) {}
        ko.f.cord.value = chip.getAttribute('data-kd-chip') || '';
        ko.afterEdit();
        if (ko.bar && ko.bar.isConnected && ko.f.cord.value) {
          ko.shut = true;
          ko.cordStatus();
          if (kf) try { ko.bar.focus({ preventScroll: true }); } catch (x) {}
          scrollUnder(ko.bar);
        }
      }
      return;
    }
    var opt = e.target && e.target.closest ? e.target.closest('[data-popout-option]') : null;
    if (opt) {
      var pop = opt.closest('popout-select'), menu = cordMenu(opt.closest('variant-selects'));
      if (pop && menu && menu.pop === pop) {
        holderOf(pop).setAttribute(PICKED, '1');
        pop.classList.remove('kd-pick-needed', 'kd-pick-bad');
        if (menu.toggle) menu.toggle.removeAttribute('aria-invalid');
        var pn = pop.parentNode ? pop.parentNode.querySelector('.kd-pick-note') : null;
        if (pn) pn.parentNode.removeChild(pn);
        if (menu.text && menu.text.textContent === PICK_TEXT) menu.text.textContent = opt.getAttribute('data-value') || '';
      }
      pickSize(pop, opt);
      return;
    }
    var t = e.target && e.target.closest ? e.target.closest(ADD) : null;
    if (!t) return;
    var handled = false;
    each(function (o) {
      if (!o.ownsButton(t)) return;
      handled = true;
      if (!o.attempt(e)) return false;
      if (o.sliderOn() && t.closest(BUY)) { o.buyNow(e); return false; }
    });
    if (!handled && t.closest('.popup-quick-view, [data-quick-view-item]')) quickView(e, t);
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('variant-selects')) return;
    if (t.type === 'radio') {
      var rm = (t.getAttribute('name') || '').match(RX_OPTNAME);
      if (rm && RX_SIZENAME.test(rm[1])) markSize(holderOf(t), norm(rm[1]));
    }
    each(function (o) { if (o.pi.contains(t)) setTimeout(function () { o.update(); }, 0); });
  }, true);

  /* ------------------------------------------------------------
     7. SECOND SLIDER (v9): the theme's add to cart posts the form to
        /cart/add. When the form carries Second slider: Yes, that one
        call goes out as /cart/add.js with two items, the necklace and
        the add-on. After a cart line is removed (/cart/change with
        quantity 0), an add-on line is lowered to the ticked necklaces
        of its _kd_addon_for variant still in the cart.
     ------------------------------------------------------------ */
  var RX_ADD = /\/cart\/add(?:\.js)?(?=[?#]|$)/, RX_CHANGE = /\/cart\/change(?:\.js)?(?=[?#]|$)/;
  var nativeFetch = window.fetch;
  function twoItems(fd) {
    var id = String(fd.get('id') || ''), o = null;
    each(function (x) {
      var f = x.form(), idIn = f ? f.querySelector('[name="id"]') : null;
      if (x.sliderOn() && idIn && String(idIn.value) === id) { o = x; return false; }
    });
    var vid = o ? o.f.slider.getAttribute('data-kd-addon-vid') : '';
    if (!o || !id || !vid) return null;
    var q = Math.max(1, parseInt(fd.get('quantity'), 10) || 1), props = {}, plan = fd.get('selling_plan');
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && typeof v === 'string') props[m[1]] = v; });
    var main = { id: +id, quantity: q, properties: props }, add = { id: +vid, quantity: q, properties: {} };
    if (plan) main.selling_plan = +plan;
    add.properties[FOR_PROP] = o.f.slider.getAttribute('data-kd-for') || '';
    add.properties[FOR_KEY] = id;
    return { items: [main, add] };
  }
  KD.twoItems = twoItems;
  function reconcile(url, res) {
    if (!res || !res.ok || !res.clone) return res;
    return res.clone().json().then(function (cart) {
      var items = (cart && cart.items) || [], jobs = [];
      items.forEach(function (it) {
        var forId = (it.properties || {})[FOR_KEY];
        if (!forId) return;
        var need = 0;
        items.forEach(function (n) { if (String(n.variant_id) === String(forId) && (n.properties || {})[SLIDER_PROP] === SLIDER_VAL) need += n.quantity; });
        if (it.quantity > need) jobs.push({ id: it.key, quantity: need });
      });
      var chain = Promise.resolve(), to = url.replace(RX_CHANGE, '/cart/change.js');
      jobs.forEach(function (j) {
        chain = chain.then(function () { return nativeFetch.call(window, to, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(j), credentials: 'same-origin' }); });
      });
      return chain.then(function () { return res; }, function () { return res; });
    }, function () { return res; });
  }
  if (nativeFetch && !nativeFetch.kdWrapped) {
    var kdFetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '', body = init && init.body;
        if (RX_ADD.test(url) && typeof FormData !== 'undefined' && body instanceof FormData && body.get('properties[' + SLIDER_PROP + ']') === SLIDER_VAL) {
          var two = twoItems(body);
          if (two) return nativeFetch.call(window, url.replace(RX_ADD, '/cart/add.js'), { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(two), credentials: 'same-origin' });
        }
        if (RX_CHANGE.test(url) && typeof body === 'string' && /"quantity"\s*:\s*0(?![0-9.])/.test(body)) {
          return nativeFetch.apply(window, arguments).then(function (res) { return reconcile(url, res); });
        }
      } catch (x) {}
      return nativeFetch.apply(window, arguments);
    };
    kdFetch.kdWrapped = true;
    window.fetch = kdFetch;
  }
  /* Buy it now with the tick on: both items into the cart, then checkout */
  Opts.prototype.buyNow = function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = this.form(), two = form && nativeFetch ? twoItems(new FormData(form)) : null;
    if (!two) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    nativeFetch.call(window, root + 'cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(two), credentials: 'same-origin' })
      .then(function (r) { window.location.href = root + (r.ok ? 'checkout' : 'cart'); }, function () { window.location.href = root + 'cart'; });
  };

  var queued = false, queueForce = false;
  function scan(force) {
    queued = false;
    var roots = document.querySelectorAll('[data-kd-opts]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].kdOpts) KD.list.push(new Opts(roots[i]));
    }
    KD.list = KD.list.filter(function (o) { return o.root.isConnected; });
    each(function (o) { o.update(force === true); });
  }
  function queue(force) {
    if (force === true) queueForce = true;
    if (queued) return;
    queued = true;
    var run = function () { if (queued) scan(queueForce); queueForce = false; };
    requestAnimationFrame(run);
    setTimeout(run, 150);
  }
  KD.refresh = scan;
  function start() {
    scan(true);
    if (window.MutationObserver) new MutationObserver(function () { queue(); }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', function () { each(function (o) { o.styled = false; }); queue(true); });
    window.addEventListener('load', function () { each(function (o) { o.styled = false; }); queue(true); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/*================================================================
  REVIEWS LINE, part of v10 (KD 9/25/2026, spec "O: Product page
  tweaks build", T2). Spec by Fabio Claudio, built by Opilio C.
  The line above the breadcrumb ("4.9", five stars, "42 reviews") is
  the review app's stars block (trust_and_barge in the main section
  of templates/product.json). The app links its score and stars to
  the listing the reviews came from, in a new tab, and has no scroll
  of its own. Now a tap anywhere on the line stays on the site:
  - if the page shows a reviews block (the app's list, grid or
    carousel further down, or a Judge.me review widget if one is ever
    switched on), a smooth scroll until the block's top sits about
    12px under the header (the header's height read at that moment);
  - if not, /pages/reviews (KD's Reviews page).
  Decided at the moment of the tap from what the page holds, so it is
  one behavior on every product. The app draws the line and the list
  only on listings that have reviews of their own. Not in quick view.
  The thin underline under the count words and the pointer are CSS,
  block 279 in assets/kd-custom-15.css.
  TO UNDO: delete this block (and block 279).
================================================================*/
(function () {
  'use strict';
  if (window.kdReviewsLine) return;
  window.kdReviewsLine = true;
  var LINE = '[id*="trust_and_barge"] .reputon-stars-widget';
  var TYPES = ['standard', 'carousel', 'carousel_extended', 'grid', 'masonry', 'basic_slide'];
  function drawn(el) {
    if (!el || !el.getClientRects().length) return false;
    var b = el.getBoundingClientRect(), cs = getComputedStyle(el);
    return b.height > 40 && cs.visibility !== 'hidden' && cs.position !== 'fixed';
  }
  /* the top of the first painted part of a block (the app's list keeps
     24 to 40px of empty padding above its card) */
  function inkTop(el) {
    var top = null, all = el.querySelectorAll('*');
    for (var i = 0; i < all.length && i < 600; i++) {
      var e = all[i], b = e.getBoundingClientRect();
      if (!b.height || !b.width || (top !== null && b.top >= top)) continue;
      var cs = getComputedStyle(e), ink = /^(IMG|SVG|svg)$/.test(e.tagName) ||
        (cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && cs.backgroundColor !== 'transparent') || cs.backgroundImage !== 'none' ||
        parseFloat(cs.borderTopWidth) > 0;
      if (!ink) for (var c = e.firstChild; c; c = c.nextSibling) { if (c.nodeType === 3 && c.textContent.trim()) { ink = true; break; } }
      if (ink && cs.visibility !== 'hidden') top = b.top;
    }
    return top === null ? el.getBoundingClientRect().top : top;
  }
  function reviewsBlock(line) {
    var list = document.querySelectorAll('[class*="-reviews-widget"][data-type], .jdgm-rev-widg, #judgeme_product_reviews');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.contains(line) || el.closest('[id*="trust_and_barge"], .popup-quick-view, [data-quick-view-item]')) continue;
      if (el.hasAttribute('data-type') && TYPES.indexOf(el.getAttribute('data-type')) < 0) continue;
      if (drawn(el)) return el;
    }
    return null;
  }
  function scrollUnder(el) {
    var KD = window.kdNativeOptions, top = inkTop(el);
    if (KD && KD.scrollUnder) return KD.scrollUnder(el, top);
    var y = Math.max(0, Math.round(window.pageYOffset + top - 12));
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); }
  }
  document.addEventListener('click', function (e) {
    var line = e.target && e.target.closest ? e.target.closest(LINE) : null;
    if (!line || line.closest('.popup-quick-view, [data-quick-view-item]')) return;
    e.preventDefault();
    var block = reviewsBlock(line);
    if (block) { scrollUnder(block); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + 'pages/reviews';
  }, true);
})();